import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import FormDialog from '../../../../library/form/components/FormDialog';
import FormTitle from '../../../../library/form/components/FormTitle'
import ItemCMNHeaderEditor from "./ItemCMNHeaderEditor"

const ItemHeaderEditor = (props) => {
    const { formObject, viewData, masterKeys, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '335px' }}
            formStyle={{ width: '743px' }} formTitle={<FormTitle formObject={formObject} masterKeys={masterKeys} value="Item Header" />}
        >
            <ItemCMNHeaderEditor formObject={formObject} viewData={viewData} {...restProps}  />
        </FormDialog>
    )
}

export default withView(ItemHeaderEditor, "itemHeader", "itemHeader,itemTech,docAttributeValue")